import React, { FC } from 'react'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'
import CustomFormRoleSelectionDrawerManagerContent from './Content'
import CustomFormRoleSelectionDrawerManagerProvider from './contexts/CustomFormRoleSelectionDrawerManager/Provider'

type Props = {
  question: CustomFormQuestion
  questionKey: string
  disabled?: boolean
}

const CustomFormRoleSelectionDrawer: FC<Props> = ({ question, disabled, questionKey }) => {
  return (
    <CustomFormRoleSelectionDrawerManagerProvider questionKey={questionKey}>
      <CustomFormRoleSelectionDrawerManagerContent question={question} disabled={disabled} />
    </CustomFormRoleSelectionDrawerManagerProvider>
  )
}

export default CustomFormRoleSelectionDrawer
